<template>
  <div class="container">
    <top num="5"></top>
    <img src="static/img/banner03.png" class="banner" alt="" />
    <div
      style="
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
    >
      <div class="main">
        <table></table>
        <p class="title">覆盖国家</p>
        <div class="blocks">
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(item, index) in list" :key="index">
              <img :src="item.url" class="medium" />
              <p>{{ item.title }}</p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div>
        <div class="main" style="background: rgb(245, 247, 247)">
        <table></table>
        <p class="title">联系我们</p>
        <div class="blocks">
          <div class="flex">
            <div>
              <img src="static/img/phone.png" alt="" />
              <p>0755-86541789</p>
            </div>
            <div>
              <img src="static/img/mail.png" alt="" />
              <p>HR@prestamoo.mx</p>
            </div>
          </div>
        </div>
      </div>
      <bottom></bottom>
      </div>
    </div>
  </div>
</template>
<script>
import Bottom from "./bottom.vue";
import top from "./top.vue";
export default {
  components: { top, Bottom },
  name: "contact",
  data() {
    return {
      list: [
        {
          url: "static/img/pic03.png",
          title: "墨西哥",
        },
        {
          url: "static/img/pic05.png",
          title: "秘鲁",
        },
        {
          url: "static/img/pic04.png",
          title: "危地马拉",
        },
      ],
    };
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
img {
  display: block;
}
.banner {
  width: 100%;
}
.blocks {
  width: 6.35rem;
  margin: 0 auto;
}
.main {
  padding-bottom: 0.447917rem;
}
.title {
  text-align: center;
  font-size: 0.208333rem;
  margin: 0.479167rem auto;
}
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.flex > div {
  display: flex;
  align-items: center;
  font-size: 0.15625rem;
}
.flex img {
  width: 0.3125rem;
  margin-right: 0.15625rem;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.el-carousel p {
  font-size: 0.125rem;
  text-align: center;
  margin: 0.2rem;
}
.medium {
  margin: 0 auto;
  /* height: 1.458333rem; */
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue